// import Link from 'next/link'

import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'
import { Text } from '@wartek-id/text'

// export const URL_ZOOM_MEETING =
//   'https://telkomsel.zoom.us/j/94281401931?pwd=LAwens7MkhAtcsn0mcb3H7xb9Tywkx.1'

const ButtonKonsultasiDaring = () => {
  return (
    <Popover className="flex-1 [&>div>div]:h-full [&>div]:h-full">
      <PopoverTrigger className="h-full w-full">
        <Button
          fullWidth
          color="white"
          size="sm"
          className="flex h-full items-center gap-1 whitespace-nowrap border !font-medium !outline-subdued"
        >
          <Icon fontSize="sm">videocam</Icon>Konsultasi Daring
        </Button>
      </PopoverTrigger>

      <PopoverContent anchor="bottom end" className="!p-4">
        <div className="space-y-3">
          <Text variant="heading-sm">
            Konsultasi Daring SIM KSPSTK (Zoom Call)
          </Text>

          <div className="space-y-3 rounded-md border border-surface-informational-default bg-surface-informational-subdued p-3">
            <Text variant="body-sm-bold">📅 Jam Operasional</Text>

            <div>
              <Text variant="body-sm-bold">Hari</Text>
              <Text variant="body-sm">Senin - Rabu</Text>
            </div>

            <div>
              <Text variant="body-sm-bold">Jam</Text>
              <Text variant="body-sm">08:00 - 09:00 WIB</Text>
            </div>
          </div>

          {/* <Link href={URL_ZOOM_MEETING} className="inline-block w-full">
            <Button
              fullWidth
              className="flex h-full items-center gap-2 border !outline-subdued"
            >
              <Icon color="inverse">videocam</Icon>Ikuti Konsultasi Daring
            </Button>
          </Link> */}
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default ButtonKonsultasiDaring
